<template>
  <div class="card-holder-box sm-qu-padding">
    <IsChildren />
    
    <CRow>
      <CCol sm="12">
        <CardHolderTable
        />
      </CCol>
    </CRow>
  </div>
</template>
<script>
import IsChildren from "../../components/IsChildren.vue";
import CardHolderTable from "../../components/CardHolderTable.vue";
export default {
    components:  { IsChildren, CardHolderTable },
    data() {
        return {
            page_total: 0,
            cardHolderData: [
                {
                    holder_name: 'TEST QQ',
                    country_code: 'EN',
                    state: 'jz',
                    zipcode: 123123,
                    city: 'city1',
                    address: 'xxx-xxx-xxx'
                },
                {
                    holder_name: 'TEST QQ2',
                    country_code: 'UE',
                    state: 'jz2',
                    zipcode: 123123,
                    city: 'city2',
                    address: 'xxx-xxx-xxx'
                }
            ]
        }
    }
}
</script>
<style scoped>
    .card-holder-box {
        margin-left: 42px;
    }
</style>